export default function Git_History() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Git History</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/history</p>
    </div>
  );
}
